import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  rescheduleClassesFormAcademyScheduleSelector,
  setRescheduleClassesFormAcademySchedule,
} from 'features/classCreation';
import AcademyScheduleSelect from 'components/AcademyScheduleSelect';
import styles from './NewScheduleSelect.module.scss';

function NewScheduleSelect() {
  const dispatch = useDispatch();
  const academySchedule = useSelector(
    rescheduleClassesFormAcademyScheduleSelector
  );

  const handleChange = useCallback(
    (value) => {
      dispatch(setRescheduleClassesFormAcademySchedule(value));
    },
    [dispatch]
  );

  return (
    <AcademyScheduleSelect
      className={classNames(styles.root, 'm-r-xs m-b-xs')}
      onChange={handleChange}
      value={academySchedule}
    />
  );
}

export default NewScheduleSelect;
